<template>
  <section class="hero">
    <div class="hero-foto">
      <img :src="require('@/assets/img/hero-estrada.jpg')" alt="" />
    </div>
    <div class="veu"></div>
    <div class="veu-2"></div>

    <div class="col hero-grade">
      <div class="hero-txt">
        <div class="selo selo--claro entra">
          <i></i> Operação ativa · coleta hoje até {{ OPERACAO.limitePedido }}
        </div>

        <h1 class="entra d1">
          Sua carga sai hoje.<br>
          A gente <span class="grad">responde por ela.</span>
        </h1>

        <p class="lead entra d2">
          Transporte rodoviário na Grande São Paulo: carga fracionada, dedicada ou em
          roteiro programado — e produtos perigosos, que é a atividade registrada da
          empresa. Valor fechado antes da coleta e acompanhamento por código até a entrega.
        </p>

        <div class="acoes entra d3">
          <router-link to="/solicitar" class="btn btn--azul">Pedir uma coleta →</router-link>
          <router-link to="/cobertura" class="btn btn--claro">Ver cobertura</router-link>
        </div>

        <div class="mini entra d4">
          <div><b>{{ OPERACAO.desde }}</b><span>operando desde</span></div>
          <div><b>{{ OPERACAO.janelaColeta }}</b><span>janela de coleta</span></div>
          <div><b>{{ COBERTURA.length }}</b><span>municípios atendidos</span></div>
        </div>
      </div>

      <div class="hero-painel">
        <PainelRastreio />
      </div>
    </div>
  </section>
</template>

<script setup>
import PainelRastreio from '@/components/PainelRastreio.vue'
import { COBERTURA, OPERACAO } from '@/config/operacao'
</script>

<style scoped>
.hero {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 620px;
  overflow: hidden;
  background: var(--noite);
}

.hero-foto { position: absolute; inset: 0; z-index: 0; }
.hero-foto img {
  width: 100%; height: 100%;
  object-fit: cover;
  transform: scale(1.06);
  animation: zoom-lento 20s var(--ease) forwards;
}
@keyframes zoom-lento { to { transform: scale(1); } }
@media (prefers-reduced-motion: reduce) { .hero-foto img { animation: none; transform: none; } }

/* dois véus: um horizontal pra legibilidade do texto, um vertical pra
   costurar com o header e com a seção seguinte */
.veu {
  position: absolute; inset: 0; z-index: 1;
  background: linear-gradient(100deg,
    rgba(10,16,24,.95) 0%, rgba(10,16,24,.87) 34%,
    rgba(10,16,24,.44) 68%, rgba(10,16,24,.62) 100%);
}
.veu-2 {
  position: absolute; inset: 0; z-index: 1;
  background: linear-gradient(180deg,
    rgba(10,16,24,.72) 0%, transparent 20%,
    transparent 70%, rgba(10,16,24,.8) 100%);
}

.hero-grade {
  position: relative; z-index: 2;
  display: grid; grid-template-columns: 1.15fr .85fr;
  gap: 56px; align-items: center;
  padding-top: 118px; padding-bottom: 64px;
  width: 100%;
}

h1 { font-size: clamp(34px, 4.6vw, 60px); font-weight: 800; color: #fff; margin-top: 22px; }
.lead { margin-top: 20px; font-size: 17px; line-height: 1.62; color: var(--texto-cl); max-width: 480px; }
.acoes { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 32px; }

.mini {
  display: flex; flex-wrap: wrap; gap: 34px;
  margin-top: 42px; padding-top: 24px;
  border-top: 1px solid var(--fio-cl);
}
.mini b {
  display: block;
  font-family: 'Archivo', sans-serif;
  font-weight: 800; font-size: 26px;
  color: #fff; letter-spacing: -.03em;
}
.mini span { display: block; font-size: 12.5px; color: var(--texto-cl); margin-top: 4px; }

@media (max-width: 1000px) {
  .hero-grade { grid-template-columns: 1fr; gap: 36px; padding-top: 104px; padding-bottom: 48px; }
  .lead { max-width: none; }
  .hero { min-height: 0; }
}
@media (max-width: 600px) {
  .mini { gap: 22px; }
  .mini b { font-size: 21px; }
}
</style>
